/**
 * @class
 * @classdesc Describes the Filter class. Every filter of the application should follow this class definition.
 */
export default class Filter {
  /**
   * @param {*} MetricKey DB's field's name
   * @param {*} Values The value of the filter (it can be an array of values)
   * @param {*} MongoType Data type of the filter (i.e. String, Boolean, etc)
   * @param {*} ParamId ParamId of the ParamListEnum that describes the different operations that can be done on the filters' type
   * @param {*} ValueCode Value of the operation related to the ParamId list
   */
  constructor(MetricKey, Values, MongoType, ParamId, ValueCode) {
    this.MetricKey = MetricKey;
    this.Values = Values;
    this.MongoType = MongoType;
    this.ParamId = ParamId;
    this.ValueCode = ValueCode;
  }

  get ValueToBackend() {
    return {
      MetricKey: this.MetricKey,
      Values: this.Values,
      MongoType: this.MongoType,
      ParamId: this.ParamId,
      ValueCode: this.ValueCode,
    };
  }
}
